import { format, formatDistanceToNowStrict } from 'date-fns'
import { PROVIDER_ICONS } from '../../../../utils/actionDisplay'

export const POLL_INTERVAL_MS = 30000

export const TABS = {
  waiting: 'waiting',
  processed: 'processed',
}

export const RESULT_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'processed', label: 'Succeeded' },
  { value: 'failed', label: 'Failed' },
]

export const WAITING_COLUMNS = {
  position: 'w-6 shrink-0',
  account: 'flex-[2] min-w-0',
  email: 'flex-[2] min-w-0',
  type: 'w-28 shrink-0',
  requestedBy: 'flex-[1.5] min-w-0',
  queued: 'w-24 shrink-0',
  status: 'w-28 shrink-0 text-right',
}

export const PROCESSED_COLUMNS = {
  chevron: 'w-3 shrink-0 -mr-1.5 flex items-center',
  account: 'flex-[2] min-w-0',
  email: 'flex-[2] min-w-0',
  type: 'w-28 shrink-0',
  requestedBy: 'flex-[1.5] min-w-0',
  finished: 'w-24 shrink-0',
  status: 'w-28 shrink-0 text-right',
}

export const STATUS_BADGES = {
  queued: { label: 'Queued', className: 'bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-gray-300' },
  retrying: { label: 'Retrying', className: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300' },
  processed: { label: 'Succeeded', className: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300' },
  failed: { label: 'Failed', className: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300' },
}

export const providerIconFor = (provider) => PROVIDER_ICONS[provider?.toLowerCase()]

export const reportTypeLabel = (row) => {
  const label = row.data_type_display || ''
  return row.provider && label.startsWith(`${row.provider} `) ? label.slice(row.provider.length + 1) : label
}

export const relativeTime = (value) => (value ? formatDistanceToNowStrict(new Date(value), { addSuffix: true }) : '–')

export const exactTime = (value) => (value ? format(new Date(value), 'yyyy-MM-dd HH:mm') : '')

export const matchesSearch = (row, query) => {
  if (!query) return true
  const needle = query.trim().toLowerCase()
  return [row.username, row.full_name, row.email, row.requested_by]
    .some(value => value?.toLowerCase().includes(needle))
}
